// extracted by mini-css-extract-plugin
module.exports = {"error":"error--zSO6m"};